module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-b18735f4!./packages/dof-side-nav/colmo.css
// module id = 529
// module chunks = 0 1